class CollectionInfiniteScroll extends HTMLElement {
  connectedCallback() {
    this.sentinel = this.querySelector('.collection-infinite-scroll__sentinel');
    this.loadingEl = this.querySelector('.collection-infinite-scroll__loading');
    this.productGrid = document.getElementById('product-grid');
    this.isLoading = false;
    this.observer = null;

    if (this.dataset.nextPage) {
      this.initObserver();
      requestAnimationFrame(() => this.checkSentinel());
    }
  }

  disconnectedCallback() {
    this.destroy();
  }

  destroy() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  initObserver() {
    if (!this.sentinel || this.observer) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.isLoading) {
            this.loadNextPage();
          }
        });
      },
      { rootMargin: '400px 0px' }
    );

    this.observer.observe(this.sentinel);
  }

  buildFetchUrl(page) {
    const sectionId = this.dataset.sectionId || this.productGrid?.dataset.id;
    const params = new URLSearchParams(window.location.search);

    params.delete('section_id');
    params.set('page', page);
    params.set('section_id', sectionId);

    return `${window.location.pathname}?${params.toString()}`;
  }

  loadNextPage() {
    const nextPage = this.dataset.nextPage;
    if (!nextPage || this.isLoading) return;

    this.isLoading = true;
    if (this.loadingEl) this.loadingEl.classList.remove('hidden');

    fetch(this.buildFetchUrl(nextPage))
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.text();
      })
      .then((responseText) => {
        const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
        const sectionRoot = parsedHTML.querySelector('[id^="shopify-section-"]') || parsedHTML;
        const newProductGrid = sectionRoot.querySelector('#product-grid');
        const newInfiniteScroll = sectionRoot.querySelector('collection-infinite-scroll');

        if (newProductGrid && this.productGrid) {
          const newItems = newProductGrid.querySelectorAll('li.grid__item');
          const existingCount = this.productGrid.querySelectorAll('li.grid__item').length;

          newItems.forEach((item, index) => {
            const clonedItem = item.cloneNode(true);
            clonedItem.classList.remove('scroll-trigger--cancel');
            if (clonedItem.hasAttribute('data-cascade')) {
              clonedItem.style.setProperty('--animation-order', existingCount + index + 1);
            }
            this.productGrid.appendChild(clonedItem);

            if (typeof initializeScrollAnimationTrigger === 'function') {
              initializeScrollAnimationTrigger(clonedItem);
            }
          });

          CollectionInfiniteScroll.removeZeroPrices(this.productGrid);
        }

        if (newInfiniteScroll?.dataset.nextPage) {
          this.dataset.nextPage = newInfiniteScroll.dataset.nextPage;
          if (!this.observer) this.initObserver();
        } else {
          delete this.dataset.nextPage;
          this.destroy();
        }
      })
      .catch((error) => {
        console.error('Collection infinite scroll:', error);
      })
      .finally(() => {
        this.isLoading = false;
        if (this.loadingEl) this.loadingEl.classList.add('hidden');
        this.checkSentinel();
      });
  }

  checkSentinel() {
    if (!this.dataset.nextPage || this.isLoading || !this.sentinel) return;

    const rect = this.sentinel.getBoundingClientRect();
    if (rect.top <= window.innerHeight + 400) {
      this.loadNextPage();
    }
  }

  static removeZeroPrices(container) {
    container.querySelectorAll('.price-item').forEach((item) => {
      if (item.textContent.trim() === '¥0') {
        item.remove();
      }
    });
  }
}

if (!customElements.get('collection-infinite-scroll')) {
  customElements.define('collection-infinite-scroll', CollectionInfiniteScroll);
}
